import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { MessageOwnerId} from "../message-owner";
import { messageOwnerIdZodSchema } from "../message-owner";

type AddMessageCommand = {
    readonly _id: string;
    readonly _type: "ADD_MESSAGE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly ownerId: MessageOwnerId;
    readonly message: string;
};

const addMessageCommandZodSchema: z.ZodSchema<AddMessageCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("ADD_MESSAGE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    ownerId: messageOwnerIdZodSchema,
    message: z.string(),
});

type AddMessageCommandCreateParams = Except<
    AddMessageCommand,
    "_id" | "_createdAt" | "_type"
> & {
    _id?: AddMessageCommand;
};

const addMessageCommandFactory = (
    params: AddMessageCommandCreateParams,
): AddMessageCommand => {
    const now = nowIsoAndUnix();
    return {
        ...params,
        _id: generateId({ prefix: "add_message_command__" }),
        _createdAt: now,
        _type: "ADD_MESSAGE_COMMAND",
    } as AddMessageCommand;
};

export { addMessageCommandFactory, addMessageCommandZodSchema };
export type { AddMessageCommand };
